const helpVideosData = {
  helpCenter: [
    {
      id: 1,
      title: 'helplist:sharelook',
      route: 'Sharelook',
      videoUrl: 'https://www.youtube.com/embed/2OtswOb8vj4',
      createdDate: '2025-10-30',
      description: 'helplist:sharelook_desc',
      viewType: 'user'
    },
    {
      id: 2,
      title: 'helplist:course_summary',
      route: 'Course Creation Summary',
      videoUrl: 'https://www.youtube.com/embed/t0E0AGmbvVU',
      createdDate: '2025-10-30',
      description: 'helplist:course_summary_desc',
      viewType: 'admin'
    },
    {
      id: 87,
      title: 'helplist:ai_course_creation',
      route: 'Full Process - AI Course Creation',
      videoUrl: 'https://www.youtube.com/embed/Vn0enwrQzfo',
      createdDate: '2025-10-30',
      description: 'helplist:ai_course_creation_desc',
      viewType: 'admin'
    },
    {
      id: 88,
      title: 'helplist:scenario_based_assessment',
      route: 'Full Process - Scenario-based Assessment (Metamaze) Creation',
      videoUrl: 'https://www.youtube.com/embed/wJD7GOBzsuo',
      createdDate: '2025-10-30',
      description: 'helplist:scenario_based_assessment_desc',
      viewType: 'admin'
    },
    {
      id: 89,
      title: 'helplist:skill_leaderboard_creation',
      route: 'Full Process - Skill Journey and Leaderboard Creation',
      videoUrl: 'https://www.youtube.com/embed/e7phvbe-B-0',
      createdDate: '2025-10-30',
      description: 'helplist:skill_leaderboard_creation_desc',
      viewType: 'admin'
    },
    {
      id: 3,
      title: 'helplist:skill_journey',
      route: 'What is a Skill Journey',
      videoUrl: 'https://www.youtube.com/embed/n6xG80tIVh0',
      createdDate: '2025-10-30',
      description: 'helplist:skill_journey_desc',
      viewType: 'user'
    },
    {
      id: 4,
      title: 'helplist:metamaze',
      route: 'What is a Metamaze',
      videoUrl: 'https://www.youtube.com/embed/hEyfdDeTTVE',
      createdDate: '2025-10-30',
      description: 'helplist:metamaze_desc',
      viewType: 'user'
    },
    {
      id: 5,
      title: 'helplist:share_shorts',
      route: 'What is Share Shorts',
      videoUrl: 'https://www.youtube.com/embed/dDZlSgORDpY',
      createdDate: '2025-10-30',
      description: 'helplist:share_shorts_desc',
      viewType: 'user'
    }
  ],
  training: [
    {
      id: 6,
      title: 'helplist:view_channel',
      route: 'How to view a video channel',
      videoUrl: 'https://www.youtube.com/embed/Px41PAVmo1E',
      createdDate: '2025-10-30',
      description: 'helplist:view_channel_desc',
      viewType: 'user'
    },
    {
      id: 7,
      title: 'helplist:take_course',
      route: 'How to take a course - Learner',
      videoUrl: 'https://www.youtube.com/embed/5vT4zMg5ayQ',
      createdDate: '2025-10-30',
      description: 'helplist:take_course_desc',
      viewType: 'user'
    },
    {
      id: 8,
      title: 'helplist:take_metamaze',
      route: 'How to take a Metamaze (Scenario-based learning)',
      videoUrl: 'https://www.youtube.com/embed/TbPrwXlU498',
      createdDate: '2025-10-30',
      description: 'helplist:take_metamaze_desc',
      viewType: 'user'
    },
    {
      id: 9,
      title: 'helplist:take_skill_journey',
      route: 'How to take a skill journey',
      videoUrl: 'https://www.youtube.com/embed/C1tH8894cv8',
      createdDate: '2025-10-30',
      description: 'helplist:take_skill_journey_desc',
      viewType: 'user'
    },
    {
      id: 59,
      title: 'helplist:listen_podcast',
      route: 'How to listen to podcast',
      videoUrl: '',
      createdDate: '2025-10-30',
      description: 'helplist:listen_podcast_desc',
      viewType: 'user'
    }
  ],
  courses: [
    {
      id: 10,
      title: 'helplist:create_course',
      route: 'How to Create a Course?',
      videoUrl: 'https://www.youtube.com/embed/NYVpr_Dr0Os',
      createdDate: '2025-10-30',
      description: 'helplist:create_course_desc',
      viewType: 'admin'
    },
    {
      id: 60,
      title: 'helplist:create_lesson',
      route: 'How to create a lesson',
      videoUrl: 'https://www.youtube.com/embed/Vn0enwrQzfo?si=kYiE9zU_OQuAc3aU',
      createdDate: '2025-11-25',
      description: 'helplist:create_lesson_desc',
      viewType: 'admin'
    },
    {
      id: 91,
      title: 'helplist:interactive_lesson_learner',
      route: 'Interactive Lesson - Learner View',
      videoUrl: 'https://www.youtube.com/embed/hw9ls9Z-mSA',
      createdDate: '2025-11-28',
      description: 'helplist:interactive_lesson_learner_desc',
      viewType: 'user'
    },
    {
      id: 92,
      title: 'helplist:interactive_lesson_admin',
      route: 'Interactive Lesson - Admin View',
      videoUrl: 'https://youtu.be/YM9WYmRK-CY',
      createdDate: '2025-11-28',
      description: 'helplist:interactive_lesson_admin_desc',
      viewType: 'admin'
    }
  ],
  coursesAi: [
    {
      id: 11,
      title: 'helplist:ai_curriculum',
      route: 'AI-assisted Curriculum Generation',
      videoUrl: 'https://www.youtube.com/embed/lBKp3ieQNTw',
      createdDate: '2025-10-30',
      description: 'helplist:ai_curriculum_desc',
      viewType: 'admin'
    }
  ],
  coursesBuilder: [
    {
      id: 12,
      title: 'helplist:intro_generation',
      route: 'Course Introduction Generation',
      videoUrl: 'https://www.youtube.com/embed/ke2wwqIScbI',
      createdDate: '2025-10-30',
      description: 'helplist:intro_generation_desc',
      viewType: 'admin'
    },
    {
      id: 13,
      title: 'helplist:ai_story_generation',
      route: 'AI Story and Real-life Story Generation',
      videoUrl: 'https://www.youtube.com/embed/vXAmF96rcVI',
      createdDate: '2025-10-30',
      description: 'helplist:ai_story_generation_desc',
      viewType: 'admin'
    },
    {
      id: 14,
      title: 'helplist:scenario_generation',
      route: 'Scenario Generation',
      videoUrl: 'https://www.youtube.com/embed/eK5OOXlxcfU',
      createdDate: '2025-10-30',
      description: 'helplist:scenario_generation_desc',
      viewType: 'admin'
    },
    {
      id: 15,
      title: 'helplist:ai_quiz_generation',
      route: 'AI Quiz Generation',
      videoUrl: 'https://www.youtube.com/embed/u1Cqw_dSo00',
      createdDate: '2025-10-30',
      description: 'helplist:ai_quiz_generation_desc',
      viewType: 'admin'
    },
    {
      id: 16,
      title: 'helplist:bullet_points',
      route: 'Generating Bullet Points',
      videoUrl: 'https://www.youtube.com/embed/ps0AWbdzksA',
      createdDate: '2025-10-30',
      description: 'helplist:bullet_points_desc',
      viewType: 'admin'
    },
    {
      id: 17,
      title: 'helplist:summary_generation',
      route: 'Summary Generation',
      videoUrl: 'https://www.youtube.com/embed/YCWs1ASczFk',
      createdDate: '2025-10-30',
      description: 'helplist:summary_generation_desc',
      viewType: 'admin'
    },
    {
      id: 18,
      title: 'helplist:add_lesson_content',
      route: 'Adding Content to a Lesson',
      videoUrl: 'https://www.youtube.com/embed/K8ZSvZ_WaHw',
      createdDate: '2025-10-30',
      description: 'helplist:add_lesson_content_desc',
      viewType: 'admin'
    },
    {
      id: 19,
      title: 'helplist:change_lesson_layout',
      route: 'Changing Lesson Page Layout',
      videoUrl: 'https://www.youtube.com/embed/FobeHdlmnl0',
      createdDate: '2025-10-30',
      description: 'helplist:change_lesson_layout_desc',
      viewType: 'admin'
    },
    {
      id: 20,
      title: 'helplist:voiceover_generation',
      route: 'Voiceover Generation',
      videoUrl: 'https://www.youtube.com/embed/Gh0tFfG2g2I',
      createdDate: '2025-10-30',
      description: 'helplist:voiceover_generation_desc',
      viewType: 'admin'
    },
    {
      id: 21,
      title: 'helplist:manual_quiz_creation',
      route: 'Manual Quiz Creation',
      videoUrl: 'https://www.youtube.com/embed/6nyX00_3dLo',
      createdDate: '2025-10-30',
      description: 'helplist:manual_quiz_creation_desc',
      viewType: 'admin'
    },
    {
      id: 22,
      title: 'helplist:ai_image_generation',
      route: 'AI Image Generation',
      videoUrl: 'https://www.youtube.com/embed/yXpIkI19TSk',
      createdDate: '2025-10-30',
      description: 'helplist:ai_image_generation_desc',
      viewType: 'admin'
    },
    // {
    //   id: 23,
    //   title: 'helplist:simulation_creation',
    //   route: 'Creating a Simulation (Sandbox Environment)',
    //   videoUrl: 'https://www.youtube.com/embed/MAwyYj15nis',
    //   createdDate: '2025-10-30',
    //   description: 'helplist:simulation_creation_desc',
    //   viewType: 'admin'
    // },
    {
      id: 24,
      title: 'helplist:course_learner_view',
      route: 'Course Learner View',
      videoUrl: 'https://www.youtube.com/embed/5vT4zMg5ayQ',
      createdDate: '2025-10-30',
      description: 'helplist:course_learner_view_desc',
      viewType: 'user'
    },
    {
      id: 85,
      title: 'helplist:simulation_learner_view',
      route: 'Simulation Learner View',
      videoUrl: "https://www.youtube.com/embed/eiKPk2_oOQ8",
      createdDate: '2025-11-24',
      description: 'helplist:simulation_learner_view_desc',
      viewType: 'user'
    },
    {
      id: 86,
      title: 'helplist:infographic_title',
      route: 'Adding Infographics to a Lesson Page',
      videoUrl: 'https://www.youtube.com/embed/9oail3Kd4RA',
      createdDate: '2025-11-24',
      description: 'helplist:infographic_desc',
      viewType: 'admin'
    },
    {
      id: 90,
      title: 'helplist:create_course_simulation',
      route: 'Simulation (Sandbox Environment) Within The Course',
      videoUrl: 'https://youtu.be/9FuzUQ7jd9I',
      createdDate: '2025-11-26',
      description: 'helplist:create_course_simulation_desc',
      viewType: 'admin'
    },
  ],
  maze: [
    {
      id: 25,
      title: 'helplist:ai_metamaze_creation',
      route: 'AI-Metamaze Creation',
      videoUrl: 'https://www.youtube.com/embed/jlicWukXT58',
      createdDate: '2025-10-30',
      description: 'helplist:ai_metamaze_creation_desc',
      viewType: 'admin'
    }
  ],
  library: [
    {
      id: 26,
      title: 'helplist:media_library',
      route: 'The Media Library',
      videoUrl: 'https://www.youtube.com/embed/bZIFTp-2nko',
      createdDate: '2025-11-04',
      description: 'helplist:media_library_desc',
      viewType: 'admin'
    },
    {
      id: 27,
      title: 'helplist:file_management',
      route: 'File Management',
      videoUrl: 'https://www.youtube.com/embed/vMHuGuylJTA',
      createdDate: '2025-11-04',
      description: 'helplist:file_management_desc',
      viewType: 'admin'
    },
    {
      id: 28,
      title: 'helplist:file_upload_repository',
      route: 'Uploading Files & Adding Files to the AI Repository',
      videoUrl: 'https://www.youtube.com/embed/VXawLC522fc',
      createdDate: '2025-11-04',
      description: 'helplist:file_upload_repository_desc',
      viewType: 'admin'
    },
    {
      id: 29,
      title: 'helplist:document_creation',
      route: 'Document creation Word, Calc, Impress',
      videoUrl: 'https://www.youtube.com/embed/v28uyx_Spss',
      createdDate: '2025-11-04',
      description: 'helplist:document_creation_desc',
      viewType: 'admin'
    },
    {
      id: 30,
      title: 'helplist:file_organization',
      route: 'File organization in Folders',
      videoUrl: 'https://www.youtube.com/embed/BTyjq9iAqAM',
      createdDate: '2025-11-04',
      description: 'helplist:file_organization_desc',
      viewType: 'admin'
    },
    {
      id: 62,
      title: 'helplist:document_creation_screen',
      route: 'Document creation using screen capture',
      videoUrl: 'https://www.youtube.com/embed/qyasi9Wz268',
      createdDate: '2025-11-04',
      description: 'helplist:document_creation_screen_desc',
      viewType: 'admin'
    },
    {
      id: 63,
      title: 'helplist:course_creation_screen',
      route: 'Course creation using screen capture',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:course_creation_screen_desc',
      viewType: 'admin'
    },
    {
      id: 64,
      title: 'helplist:downloads_center',
      route: 'Downloads Center',
      videoUrl: 'https://www.youtube.com/embed/DcPb5dtyOTc',
      createdDate: '2025-11-04',
      description: 'helplist:downloads_center_desc',
      viewType: 'admin'
    }
  ],
  reports: [
    {
      id: 31,
      title: 'helplist:reports_analytics',
      route: 'Reports and Analytics',
      videoUrl: 'https://www.youtube.com/embed/kcIRcK96MRc',
      createdDate: '2025-11-04',
      description: 'helplist:reports_analytics_desc',
      viewType: 'admin'
    },
    {
      id: 65,
      title: 'helplist:reports_detailed',
      route: 'Reports and Analytics Detailed',
      videoUrl: 'https://www.youtube.com/embed/2uYTpg1ZXEc',
      createdDate: '2025-11-04',
      description: 'helplist:reports_detailed_desc',
      viewType: 'admin'
    },
    {
      id: 66,
      title: 'helplist:workshop_report',
      route: 'Workshop report',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:workshop_report_desc',
      viewType: 'admin'
    },
    {
      id: 67,
      title: 'helplist:user_report',
      route: 'User report',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:user_report_desc',
      viewType: 'admin'
    },
    {
      id: 68,
      title: 'helplist:course_report',
      route: 'Course report',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:course_report_desc',
      viewType: 'user'
    },
    {
      id: 69,
      title: 'helplist:live_events_report',
      route: 'Live events report',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:live_events_report_desc',
      viewType: 'user'
    },
    {
      id: 70,
      title: 'helplist:metamaze_reports',
      route: 'Metamaze reports',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:metamaze_reports_desc',
      viewType: 'admin'
    },
    {
      id: 71,
      title: 'helplist:live_assessments_reports',
      route: 'Live assessment reports',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:live_assessments_reports_desc',
      viewType: 'admin'
    },
    {
      id: 72,
      title: 'helplist:skill_journey_reports',
      route: 'Skill journey reports',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:skill_journey_reports_desc',
      viewType: 'admin'
    },
    {
      id: 73,
      title: 'helplist:sharesphere_report',
      route: 'Sharesphere report',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:sharesphere_report_desc',
      viewType: 'admin'
    }
  ],
  skillJourney: [
    {
      id: 32,
      title: 'helplist:create_skill_journey',
      route: 'How to create a skill journey',
      videoUrl: 'https://www.youtube.com/embed/uJ_8fwy_cAk',
      createdDate: '2025-10-30',
      description: 'helplist:create_skill_journey_desc',
      viewType: 'admin'
    }
  ],
  podcast: [
    {
      id: 33,
      title: 'helplist:podcast_creation',
      route: 'Podcast Creation',
      videoUrl: 'https://www.youtube.com/embed/9fsA01j_RV8',
      createdDate: '2025-10-30',
      description: 'helplist:podcast_creation_desc',
      viewType: 'admin'
    }
  ],
  channel: [
    {
      id: 34,
      title: 'helplist:video_channel_creation',
      route: 'Video channel creation',
      videoUrl: 'https://www.youtube.com/embed/UXVbXVlEbFI',
      createdDate: '2025-10-30',
      description: 'helplist:video_channel_creation_desc',
      viewType: 'admin'
    }
  ],
  reel: [
    {
      id: 35,
      title: 'helplist:short_video_creation',
      route: 'Short video creation',
      videoUrl: 'https://www.youtube.com/embed/dlOYW6af75M',
      createdDate: '2025-10-30',
      description: 'helplist:short_video_creation_desc',
      viewType: 'user'
    },
    {
      id: 36,
      title: 'helplist:short_video_admin',
      route: 'Short video admin view',
      videoUrl: 'https://www.youtube.com/embed/5H6DKzfZmkU',
      createdDate: '2025-10-30',
      description: 'helplist:short_video_admin_desc',
      viewType: 'admin'
    }
  ],
  trivia: [
    {
      id: 37,
      title: 'helplist:create_trivia',
      route: 'Creating a Trivia',
      videoUrl: 'https://www.youtube.com/embed/s2HXJYcf2-M',
      createdDate: '2025-10-30',
      description: 'helplist:create_trivia_desc',
      viewType: 'admin'
    },
    {
      id: 74,
      title: 'helplist:take_trivia',
      route: 'How to take a trivia - Learner',
      videoUrl: 'https://www.youtube.com/embed/sWmv89u72NI',
      createdDate: '2025-10-30',
      description: 'helplist:take_trivia_desc',
      viewType: 'user'
    }
  ],
  management: [
    {
      id: 38,
      title: 'helplist:add_users',
      route: 'How to add users',
      videoUrl: 'https://www.youtube.com/embed/IzfB3KT3XZY',
      createdDate: '2025-10-30',
      description: 'helplist:add_users_desc',
      viewType: 'admin'
    },
    {
      id: 39,
      title: 'helplist:add_group',
      route: 'How to add a group',
      videoUrl: 'https://www.youtube.com/embed/5tY5vPPUQJI',
      createdDate: '2025-10-30',
      description: 'helplist:add_group_desc',
      viewType: 'admin'
    }
  ],
  coaching: [
    {
      id: 40,
      title: 'helplist:virtual_coach',
      route: 'Virtual Coach',
      videoUrl: 'https://www.youtube.com/embed/4vWfTqQ2uh0',
      createdDate: '2025-10-30',
      description: 'helplist:virtual_coach_desc',
      viewType: 'admin'
    },
    {
      id: 41,
      title: 'helplist:coaching_session_creation',
      route: 'Coaching Session Creation',
      videoUrl: 'https://www.youtube.com/embed/xlTytbcEOHU',
      createdDate: '2025-10-30',
      description: 'helplist:coaching_session_creation_desc',
      viewType: 'admin'
    },
    {
      id: 42,
      title: 'helplist:booking_coaching_slot',
      route: 'Booking a coaching session slot',
      videoUrl: 'https://www.youtube.com/embed/g3Tlf5Ig0YM',
      createdDate: '2025-10-30',
      description: 'helplist:booking_coaching_slot_desc',
      viewType: 'user'
    }
  ],
  workshop: [
    {
      id: 43,
      title: 'helplist:my_workshop',
      route: 'My Workshop',
      videoUrl: 'https://www.youtube.com/embed/zj7GooO5v4U',
      createdDate: '2025-11-04',
      description: 'helplist:my_workshop_desc',
      viewType: 'admin'
    },
    {
      id: 44,
      title: 'helplist:add_scorm',
      route: 'How to add SCORM in Sharelook',
      videoUrl: 'https://www.youtube.com/embed/3LbP4rV7q5c?si=mXUFbTsRAuRt3zgp',
      createdDate: '2025-11-12',
      description: 'helplist:add_scorm_desc',
      viewType: 'admin'
    },
    {
      id: 45,
      title: 'helplist:edit_skill_journey',
      route: 'How to edit a skill journey',
      videoUrl: 'https://www.youtube.com/embed/fdcDv2QrUcM',
      createdDate: '2025-11-04',
      description: 'helplist:edit_skill_journey_desc',
      viewType: 'admin'
    },
    {
      id: 46,
      title: 'helplist:edit_live_event',
      route: 'How to edit live event',
      videoUrl: 'https://www.youtube.com/embed/PEdTbM0RBhI',
      createdDate: '2025-11-04',
      description: 'helplist:edit_live_event_desc',
      viewType: 'admin'
    },
    {
      id: 47,
      title: 'helplist:clone_course',
      route: 'How to clone a course',
      videoUrl: 'https://www.youtube.com/embed/AGgnwXKKAzc',
      createdDate: '2025-11-04',
      description: 'helplist:clone_course_desc',
      viewType: 'admin'
    },
    {
      id: 48,
      title: 'helplist:clone_metamaze',
      route: 'How to clone a Metamaze',
      videoUrl: 'https://www.youtube.com/embed/8OhMCHwn5pk',
      createdDate: '2025-11-04',
      description: 'helplist:clone_metamaze_desc',
      viewType: 'admin'
    },
    {
      id: 49,
      title: 'helplist:delete_skill_journey',
      route: 'How to delete a skill journey',
      videoUrl: 'https://www.youtube.com/embed/C5pF-Rdd64E',
      createdDate: '2025-11-04',
      description: 'helplist:delete_skill_journey_desc',
      viewType: 'admin'
    },
    {
      id: 50,
      title: 'helplist:delete_live_event',
      route: 'How to delete live event',
      videoUrl: 'https://www.youtube.com/embed/AqxfUrf4d2w',
      createdDate: '2025-11-04',
      description: 'helplist:delete_live_event_desc',
      viewType: 'admin'
    },
    {
      id: 51,
      title: 'helplist:edit_course',
      route: 'How to edit a course',
      videoUrl: 'https://www.youtube.com/embed/Tp-YWrW01Zk',
      createdDate: '2025-11-04',
      description: 'helplist:edit_course_desc',
      viewType: 'admin'
    },
    {
      id: 52,
      title: 'helplist:delete_metamaze',
      route: 'How to delete a Metamaze',
      videoUrl: 'https://www.youtube.com/embed/v8P3yus7aVY',
      createdDate: '2025-11-04',
      description: 'helplist:delete_metamaze_desc',
      viewType: 'admin'
    },
    {
      id: 53,
      title: 'helplist:delete_podcast',
      route: 'How to delete a podcast',
      videoUrl: 'https://www.youtube.com/embed/YvdLy7AH520',
      createdDate: '2025-11-04',
      description: 'helplist:delete_podcast_desc',
      viewType: 'admin'
    },
    {
      id: 54,
      title: 'helplist:delete_video_channel',
      route: 'How to delete video channel',
      videoUrl: 'https://www.youtube.com/embed/F_CfWQXgKsU',
      createdDate: '2025-11-04',
      description: 'helplist:delete_video_channel_desc',
      viewType: 'admin'
    },
    {
      id: 55,
      title: 'helplist:edit_video_channel',
      route: 'How to edit a video channel',
      videoUrl: 'https://www.youtube.com/embed/xBNy0HXHJYg',
      createdDate: '2025-11-04',
      description: 'helplist:edit_video_channel_desc',
      viewType: 'admin'
    },
    {
      id: 56,
      title: 'helplist:delete_course',
      route: 'How to delete a course',
      videoUrl: 'https://www.youtube.com/embed/yBBLleKEUM8',
      createdDate: '2025-11-04',
      description: 'helplist:delete_course_desc',
      viewType: 'admin'
    },
    {
      id: 57,
      title: 'helplist:edit_metamaze',
      route: 'How to edit a Metamaze',
      videoUrl: 'https://www.youtube.com/embed/Ve7g7tKObbw',
      createdDate: '2025-11-04',
      description: 'helplist:edit_metamaze_desc',
      viewType: 'admin'
    },
    {
      id: 58,
      title: 'helplist:edit_podcast',
      route: 'How to edit a podcast',
      videoUrl: 'https://www.youtube.com/embed/cjq7cGto1Ec',
      createdDate: '2025-11-04',
      description: 'helplist:edit_podcast_desc',
      viewType: 'admin'
    },
    {
      id: 75,
      title: 'helplist:create_live_event',
      route: 'How to create a live event',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:create_live_event_desc',
      viewType: 'admin'
    },
    {
      id: 76,
      title: 'helplist:translate_course',
      route: 'How to translate a course',
      videoUrl: 'https://www.youtube.com/embed/ZlrIsFV34QQ',
      createdDate: '2025-11-04',
      description: 'helplist:translate_course_desc',
      viewType: 'admin'
    }
  ],
  leaderboard: [
    {
      id: 77,
      title: 'helplist:create_competition',
      route: 'How to create a competition',
      videoUrl: 'https://www.youtube.com/embed/zlEKOxZSX9Q',
      createdDate: '2025-11-04',
      description: 'helplist:create_competition_desc',
      viewType: 'admin'
    },
    {
      id: 78,
      title: 'helplist:leaderboard_settings',
      route: 'Leaderboard Settings',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:leaderboard_settings_desc',
      viewType: 'admin'
    },
    {
      id: 79,
      title: 'helplist:leaderboard_learner_view',
      route: 'Leaderboard - Learner view',
      videoUrl: 'https://www.youtube.com/embed/uFUhUQ3EiRQ',
      createdDate: '2025-11-04',
      description: 'helplist:leaderboard_learner_view_desc',
      viewType: 'user'
    }
  ],
  marketplace: [
    {
      id: 80,
      title: 'helplist:marketplace',
      route: 'The Marketplace',
      videoUrl: 'https://www.youtube.com/embed/Q2YL_IMq6_A',
      createdDate: '2025-11-04',
      description: 'helplist:marketplace_desc',
      viewType: 'admin'
    },
    {
      id: 81,
      title: 'helplist:buy_course',
      route: 'How to buy a course',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:buy_course_desc',
      viewType: 'user'
    },
    {
      id: 82,
      title: 'helplist:book_coaching',
      route: 'How to book a coaching session',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:book_coaching_desc',
      viewType: 'user'
    },
    {
      id: 83,
      title: 'helplist:buy_podcast',
      route: 'How to buy a podcast',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:buy_podcast_desc',
      viewType: 'user'
    },
    {
      id: 84,
      title: 'helplist:subscribe_channel',
      route: 'How to buy/subscribe to a video channel',
      videoUrl: '',
      createdDate: '2025-11-04',
      description: 'helplist:subscribe_channel_desc',
      viewType: 'user'
    }
  ]
}

// add a slug-based route
Object.keys(helpVideosData).forEach(category => {
  helpVideosData[category] = helpVideosData[category].map(video => ({
    ...video,
    route: video.route
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
  }))
})

export default helpVideosData
